import { FieldTypes } from "lib/types";
import { compose, join, juxt, toUpper, head, tail, ifElse, equals, identity } from 'ramda';

const isHtml = (str: string): boolean => {
  if (!str || !str?.length || isLink(str)) return false;

  const fragment = document.createRange().createContextualFragment(str);
  fragment.querySelectorAll('*').forEach(el => el.parentNode.removeChild(el));
  
  return !(fragment.textContent || '').trim();
}

const isLink = (str: string): boolean => {
  if (!str || !str?.length) return false;
  return !(!str.startsWith(`http://`) && !str.startsWith(`https://`));
}

export const getStringType = (str: string) => {
  if (isLink(str)) return FieldTypes.LINK;
  if (isHtml(str)) return FieldTypes.HTML;
  
  return FieldTypes.TEXT;
}

// TODO: Simple test
const capitalize = compose(
  join(''),
  juxt([compose(toUpper, head), tail])
);

// TODO: Simple test
export const capitalizeOrNull = ifElse(equals(null), identity, capitalize);

// TODO: Simple test
export const uppercaseOrNull = ifElse(equals(null), identity, toUpper);
